import { usePropertyTeamQuery } from '../queries/property-team.query';
import { usePropertyAccessDialogStore } from '../stores/property-access-dialog.store';

/**
 * For the pages of one unit. A colleague who can only view it sees every control as usual; a click
 * on anything marked data-manage-action - the button that starts a change, before any dialog or
 * form it opens - is stopped there and opens the property access dialog instead. A marked button
 * may name its unit (data-manage-action="<propertyId>"): one for another unit than the page's, such
 * as a renter's inquiry on a different property, is left to the backend, whose refusal opens the
 * dialog for that unit. Bind the returned handler as a capture-phase click listener on the page's root.
 */
export function useManageActionGuard(propertyId: () => string | undefined) {
  const teamQuery = usePropertyTeamQuery(() => ({ kind: 'property', id: propertyId() ?? '' }));
  const accessDialog = usePropertyAccessDialogStore();

  return function guardManageAction(event: MouseEvent) {
    const id = propertyId();

    if (!id || teamQuery.data.value?.canManage !== false) return;

    const marked = (event.target as HTMLElement | null)?.closest('[data-manage-action]');
    const markedUnit = marked?.getAttribute('data-manage-action');

    if (!marked || (markedUnit && markedUnit !== id)) return;

    event.preventDefault();
    event.stopPropagation();
    accessDialog.open(id);
  };
}
